export default __webpack_public_path__ + "static/media/laura.571f8908.png";